import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const [legalModal, setLegalModal] = useState<'terms' | 'privacy' | null>(null);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="py-16 px-6 bg-black" data-id="element-100" data-mp="36pft9v0kpr4p">
        <div className="max-w-7xl mx-auto" data-id="element-101" data-mp="36q93j5yqqyrl">
          <div className="flex flex-col items-center text-center" data-id="element-102" data-mp="36n3bbhutfgrn">
            {/* Logo */}
            <h3 className="font-serif text-2xl text-white mb-6" data-id="element-103" data-mp="3ud7g3sjqpmk8">
              Alexaaa Narvaez
            </h3>

            {/* Divider */}
            <div className="w-full max-w-xs h-px bg-white/10 mb-8" data-id="element-104" data-mp="3lf58uv9exxoi" />

            {/* Copyright */}
            <p className="text-white/40 text-sm font-light" data-id="element-105" data-mp="3qcniknv98gxk">
              © 2025 Alexaaa Narvaez. {t('footer.rights')}
            </p>

            {/* Legal Links */}
            <div className="flex items-center gap-6 mt-4" data-id="element-106" data-mp="2eya1q2yx51r1">
              <button onClick={() => setLegalModal('terms')} className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer" data-id="element-107" data-mp="2ezut5jpxs4ko">
                {t('footer.terms')}
              </button>
              <button onClick={() => setLegalModal('privacy')} className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer" data-id="element-108" data-mp="3v89cc9gb3le8">
                {t('footer.privacy')}
              </button>
            </div>

            {/* Age Disclaimer */}
            <p className="text-white/30 text-xs mt-6 max-w-md" data-id="element-109" data-mp="34p8h5l5tqh7">
              {t('footer.age')}
            </p>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal isOpen={legalModal !== null} onClose={() => setLegalModal(null)} type={legalModal || 'terms'} data-id="element-110" data-mp="cu0hytbykx5m" />
    </>;
}